<template>
  <div class="full-control">
    {{issues}}
    <div class="loader with-padding" v-if="status === 'Fetching'">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-list v-else-if="issues.length" style="margin-top: 40px;">
      <v-list-group
        v-for="issue in issues"
        :key="issue._id"
        no-action
        class="hover-darken row"
      >
        <v-list-tile slot="activator">
          <Annotations
            v-if="issue.annotations.length"
            :show-annotations="modal"
            @close="modal = false"
            :issue="issue"
          />
          <v-list-tile-avatar tile class="screencap">
            <img :src="issue.screenshotUrl" alt="Issue">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ issue.name }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="issue.annotations.length">
            <v-list-tile-title @click="modal = true;">
              <v-icon>open_in_new</v-icon>
            </v-list-tile-title>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-list-tile-title>{{ (issue.clientStart || issue.created) | timeSince }}</v-list-tile-title>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile
        v-for="(annotation, index) in issue.annotations"
        :key="annotation._id"
        class="detail-expand"
        v-if="issue.annotations.length"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{index + 1}}. {{ annotation.description }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="issue.annotations.length == 0" class="detail-expand">
          <v-list-tile-content>
            <v-list-tile-title>No annotations for this issue.</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
    </v-list>
    <h1 v-else-if="errMessage" class="error-fetching">
      {{ errMessage }}
    </h1>
    <h1 class="no-issues" v-else>
      No Issues for this recording.
    </h1>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Annotations from './Annotations';

export default {
  name: 'IssuesList',
  components: {
    Annotations,
  },
  hagridActions: ['issues/getIssues'],
  data() {
    // Searching doesnt work, but the local state is wired up to the input
    return {
      search: '',
      modal: false,
    };
  },
  computed: {
    ...mapState({
      issues: state => _.sortBy(state.issues.data, 'created').reverse(),
      status: state => state.issues.status,
      errMessage: state => state.issues.errMessage,
    }),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.issue-inset {
  align-items: flex-end;
}
.screencap {
  margin-left: 90px;
  width: 100px;
}
.screencap img {
  width: 80px;
  height: auto;
  max-height: 80px;
}
.row {
  padding: 25px 0px;
}
.detail-expand {
  padding-top: 25px;
  margin-left: 135px;
}
.no-issues {
  padding-top: 50px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/IssuesList.vue